'use client';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { paths } from '../../../routes/paths';
import { useTabs } from '../../../hooks/use-tabs';
import { AccountGeneral } from '../account-general';
import { AccountBilling } from '../account-billing';
import { Iconify } from '../../../components/iconify';
import { AccountSocialLinks } from '../account-social-links';
import { DashboardContent } from '../../../layouts/dashboard';
import { AccountNotifications } from '../account-notifications';
import { AccountChangePassword } from '../account-change-password';
import { CustomBreadcrumbs } from '../../../components/custom-breadcrumbs';
// import { useFacebookSessionSync } from '../../../hooks/use-facebook-session-sync';
import {
  _userAbout,
  _userPlans,
  _userPayment,
  _userInvoices,
  _userAddressBook,
} from '../../../_mock';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { endpoints } from '@/utils/axios';

// ----------------------------------------------------------------------

const TAB_CONFIGS = [
  {
    value: 'general',
    label: 'General',
    icon: <Iconify icon="solar:user-id-bold" width={24} />,
    render: () => <AccountGeneral />,
  },
  {
    value: 'billing',
    label: 'Billing',
    icon: <Iconify icon="solar:bill-list-bold" width={24} />,
    render: () => (
      <AccountBilling
        plans={_userPlans}
        cards={_userPayment}
        invoices={_userInvoices}
        addressBook={_userAddressBook}
      />
    ),
  },
  {
    value: 'notifications',
    label: 'Notifications',
    icon: <Iconify icon="solar:bell-bing-bold" width={24} />,
    render: () => <AccountNotifications />,
  },
  {
    value: 'social',
    label: 'Social Links',
    icon: <Iconify icon="solar:share-bold" width={24} />,
    render: () => <AccountSocialLinks socialLinks={_userAbout.socialLinks} />,
  },
  {
    value: 'security',
    label: 'Security',
    icon: <Iconify icon="ic:round-vpn-key" width={24} />,
    render: () => <AccountChangePassword />,
  },
];

// ----------------------------------------------------------------------

export function AccountView() {
  const tabs = useTabs('general');

  // Sync Facebook data from sessionStorage to session
  // useFacebookSessionSync();

  return (
    <DashboardContent>
      <CustomBreadcrumbs
        heading="Account"
        links={[
          { name: 'Dashboard', href: paths.dashboard.root },
          { name: 'Account', href: paths.dashboard.account },
          { name: 'Account' },
        ]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />

      <Tabs value={tabs.value} onChange={tabs.onChange} sx={{ mb: { xs: 3, md: 5 } }}>
        {TAB_CONFIGS.map(({ value, label, icon }) => (
          <Tab key={value} label={label} icon={icon} value={value} />
        ))}
      </Tabs>

      {TAB_CONFIGS.find((tab) => tab.value === tabs.value)?.render()}
    </DashboardContent>
  );
}
